import GlobalStyles from "@mui/material/GlobalStyles";
import { useColorScheme, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useMemo } from "react";
import { ToastContainer, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useTranslate } from "@/hooks";

import { ToastMascot } from "./ToastMascot";
import { TOAST_AUTO_CLOSE_MS, TOAST_LIMIT, TOAST_TITLE_KEYS } from "./data";
import { toastGlobalStyles } from "./styles";
import { ToastTitles } from "./type";

// Keyframes live in toastGlobalStyles, so a phone and reduced motion can swap them.
const SkyTransition = cssTransition({
  enter: "toast-enter",
  exit: "toast-exit",
  collapseDuration: 220,
});

export const ThemedToastContainer = () => {
  const theme = useTheme();
  const translate = useTranslate();
  const { mode, systemMode } = useColorScheme();
  const resolvedMode = (systemMode || mode) as "light" | "dark";
  // Under the header rather than over its buttons: a toast that says "sign
  // in" used to cover the Login and Sign up buttons.
  const wideHeader = useMediaQuery(theme.breakpoints.up("md"));
  const titles = useMemo<ToastTitles>(
    () =>
      Object.fromEntries(
        Object.entries(TOAST_TITLE_KEYS).map(([type, key]) => [type, translate(key)]),
      ),
    [translate],
  );

  return (
    <>
      <GlobalStyles styles={(t) => toastGlobalStyles(t, titles)} />
      <ToastContainer
        position="top-right"
        autoClose={TOAST_AUTO_CLOSE_MS}
        limit={TOAST_LIMIT}
        transition={SkyTransition}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        icon={ToastMascot}
        theme={resolvedMode}
        style={{ top: wideHeader ? 85 : 76 }}
      />
    </>
  );
};
